import React, { useState } from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter, AlertDialogCancel,
} from "../ui/alert-dialog";
import { Textarea } from "../ui/textarea";

/** Rejection always requires a reason (Recruitment Deep Audit requirement) - the backend
 * also enforces this (recruitment_service.set_status raises 400 without one), this dialog
 * just gives the recruiter a clear, deliberate confirmation step before it happens. */
export const RejectApplicantDialog = ({ open, onOpenChange, onConfirm }) => {
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleConfirm = async () => {
    if (!reason.trim()) return;
    setSubmitting(true);
    try {
      await onConfirm(reason.trim());
      setReason("");
    } catch (e) {
      // Error is already surfaced via toast by the page-level action helper - keep the
      // dialog open with the reason intact so the recruiter can retry.
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={(next) => { if (!submitting) { onOpenChange(next); if (!next) setReason(""); } }}>
      <AlertDialogContent data-testid="reject-applicant-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Reject Application</AlertDialogTitle>
          <AlertDialogDescription>
            This moves the applicant to REJECTED, a final status. A reason is required and is kept on the
            applicant's record and audit trail.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <Textarea
          data-testid="reject-reason-input"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Reason for rejecting this applicant (required)"
          rows={3}
        />
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="reject-dialog-cancel" disabled={submitting}>Back</AlertDialogCancel>
          <button
            data-testid="reject-dialog-confirm"
            disabled={!reason.trim() || submitting}
            onClick={handleConfirm}
            className="px-4 py-2 rounded-lg bg-red-600 text-white text-sm font-semibold hover:bg-red-700 disabled:opacity-50"
          >
            {submitting ? "Rejecting..." : "Confirm Rejection"}
          </button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
